export default __webpack_public_path__ + "static/media/cycle_img.edd0c24e.png";